import React from 'react'
import { connect } from 'react-redux'

import Hero from 'common/Hero'
import HeroTitle from 'common/Hero/title'

import PageContent from 'common/PageContent'
import Section from 'common/Section'
import PositionsTable from 'common/PositionsTable'

import { setTitle } from 'reducers/global'

class Openings extends React.Component {
  constructor (props) {
    super(props)

    props.dispatch(setTitle('All Openings'))
  }

  render () {
    return (
      <div>
        <Hero background='https://d2u7nrdrppwhsn.cloudfront.net/career/all_openings.jpg'>
          <HeroTitle>
          All Openings
          </HeroTitle>
        </Hero>
        <PageContent>
          <Section>
            <PositionsTable />
          </Section>
        </PageContent>
      </div>
    )
  }
}

export default connect()(Openings)
